export default {
  name: 'account--warehouse',
  apiService: 'account',
  apiPath: '/admin/warehouse',
};